interface Options {
    next: () => void;
    text: string;
}

const Button = ({ next, text }: Options) => {
    return (
        <button className="bg-yellow-bb text-blue-bb-1 text-base rounded-[4px] px-4 py-3 uppercase font-bold h-10 flex items-center hover:opacity-85 transition-all" onClick={() => next()}>
            {text}
        </button>
    );
};

export default Button;
